import React from 'react';
import './App.css';
import {Stack,  Typography, Fade, Slide, Link} from '@mui/material';


function App() {

  return (
    <div className="App"  >
		<Typography variant="h5" > <br/></Typography>
		 <Fade in timeout={2000}>
			<div>
				<Stack>
					<Slide direction={'right'} in={true} timeout={1500}> 
						<img src={process.env.PUBLIC_URL +"/img/ocv_cover_square.jpg"} style={{width:"250px", height:"250px"}}/>
					</Slide>
				</Stack>
				<Stack direction="row" alignItems="center" sx={{ p: 2 }}>
					<Typography variant="h3" style={{color:"#F0F0F0"}} align="center" > 
					Victory Saber S3D  					
					</Typography>	
					<br/>				
				</Stack>
				<Stack direction="row" sx={{ p: 2 }}>				
					<Typography variant="body" style={{color:"#F0F0F0"}} align="left"> 
						Story Line: <br/>
						You are driving the fighter "Victory Saber" and rushing to earth in outer space which was captured by unknow alien.<br/>
						<br/>
						This is a third person view shooter game which enabling stereoscopic 3d on HTC EVO3D, LG Optimus 3D and LG LG Optimus 3D max.<br/>
						<br/>
						You can use on screen button or using gyro to fly around the space.<br/>
						Slide on screen to lock and shoot enemys.<br/>
						<br/>
						On Gear VR You can use touchpad to fly around the space.<br/>
						Look around to lock and shoot enemys.<br/>
						Also work on Oculus Go.
						<br/>
						<br/>
						<br/>
						This trial is a underdevelopment prototype. 
						<br/>
						<br/>
					</Typography>				
				</Stack>
				<Stack sx={{ p: 2 }} >
				<Stack>
				<Slide direction={'right'} in={true} timeout={1500}> 
					<Typography variant='h5' align='left'style={{color:"#F0F0F0"}} >Oculus Go Screenshot
						<br/>
						<br/>
					</Typography>
					
				</Slide>
				</Stack>
				<Slide direction={'right'} in={true} timeout={1500} > 
					<Stack  spacing={3} direction={'row'}>
						<img src="./img/OVR_scrshot1.jpg" width="319" height="180" />
						<img src="./img/OVR_scrshot2.jpg" width="319" height="180" />            
					</Stack>
				</Slide>
				<Slide  direction={'right'} in={true} timeout={1500} > 
					<Stack  spacing={3} direction={'row'}>
					<img src="./img/OVR_scrshot3.jpg" width="319" height="180" />
					<img src="./img/OVR_scrshot4.jpg" width="319" height="180" />
					</Stack>
				</Slide>
				<Slide direction={'right'} in={true} timeout={1500} > 
					<Stack spacing={3} direction={'row'}>
						<img src="./img/OVR_scrshot5.jpg" width="319" height="180" />
					</Stack>
				</Slide>
				<br/>
				<br/>

			</Stack>
			<Stack align='left'>
				
				<Typography variant="h4" style={{color:"#F0F0F0"}}  > Oculus Go demo version Meta link:<br/></Typography>
				<Link href="https://www.meta.com/experiences/victory-saber-s3d-trial/1459326024128229/" >https://www.meta.com/experiences/victory-saber-s3d-trial/1459326024128229/</Link>
				<br/>
				<br/>
			</Stack>
			<Stack align='left'>
				<Typography variant="h4" style={{color:"#F0F0F0"}} > The 3D effect on LG P720:<br/></Typography>
				<video poster='./img/S3dEffect.jpg' width="740" height="360" controls  loop muted>
                    <source src="./img/S3dEffect.webm" type='video/webm' />    
				</video>
			</Stack>
			<p align='left' style={{color:"#F0F0F0"}}>©Zephyr Studio, Zephyr Lyh, 2013-2025 copyright reserved.</p>
		</div>					
		
		</Fade>
    </div>
  );
}

export default App;
